import React from 'react';
import { AnnouncementBar } from './components/AnnouncementBar';
import { MetaPixel } from './components/MetaPixel';
import { HeroSection } from './components/HeroSection';
import { StatsBar } from './components/StatsBar';
import { TransformationSection } from './components/TransformationSection';
import { PainPointsSection } from './components/PainPointsSection';
import { KitContentsSection } from './components/KitContentsSection';
import { InstantAccessSection } from './components/InstantAccessSection';
import { BonusesSection } from './components/BonusesSection';
import { PricingSection } from './components/PricingSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { FAQSection } from './components/FAQSection';
import { FinalCTASection } from './components/FinalCTASection';
import { Footer } from './components/Footer';
interface AppProps {
  showTopBar?: boolean;
}
export function App({
  showTopBar = true
}: AppProps) {
  return <div className="min-h-screen w-full bg-brand-main font-sans text-brand-text selection:bg-brand-amber/25" data-id="element-0" data-mp="3ijfvg0pldyf5">
      <MetaPixel data-id="element-1" data-mp="3mjq45l4rr2xp" />
      {showTopBar && <AnnouncementBar data-id="element-2" data-mp="3rcj6y3gog175" />}
      <main data-id="element-3" data-mp="3rbzpsoyupgu6">
        <HeroSection data-id="element-4" data-mp="3rdkgg3i1ofmr" />
        <StatsBar data-id="element-5" data-mp="3rd189ei755lx" />
        <TransformationSection data-id="element-6" data-mp="3relwkmdx3sbc" />
        <PainPointsSection data-id="element-7" data-mp="67yvnd9206b" />
        <KitContentsSection data-id="element-8" data-mp="5gfdawxfswe" />
        <InstantAccessSection data-id="element-9" data-mp="7ssnarqpf34" />
        <BonusesSection data-id="element-10" data-mp="2zlld2w2kqak3" />
        <PricingSection data-id="element-11" data-mp="2zmeo498kfm81" />
        <GuaranteeSection data-id="element-12" data-mp="2zn6actg9w7ln" />
        <TestimonialsSection data-id="element-13" data-mp="33mf2xuzktzfm" />
        <FAQSection data-id="element-14" data-mp="33nq73vwxp979" />
        <FinalCTASection data-id="element-15" data-mp="33n6xr3lcnt4u" />
      </main>
      <Footer data-id="element-16" data-mp="38lrqkhy9vaj9" />
    </div>;
}